import type { ButtonHTMLAttributes, FunctionComponent, ReactElement } from 'react';

import styles from './NavButton.module.css';

export interface NavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const NavButton: FunctionComponent<NavButtonProps> = ({ children, ...rest }): ReactElement => (
  <button data-testid="nav-button" className={styles.navButton} type="button" {...rest}>
    <span className={styles.navButton__innerWrapper}>{children}</span>
  </button>
);
